import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormControlEx } from '../../core/component/forms/form-control';
import { InformationChannelKind } from '../model/esignatory';

// Keeps contact requirements in sync with the selected signing notification channel.
export function configureESignatoryContactValidation(signatoryForm: FormGroup): Subscription {
  const email = signatoryForm.controls['email'] as FormControlEx;
  const phone = signatoryForm.controls['phone'] as FormControlEx;
  const informationChannel = signatoryForm.controls['informationChannel'] as FormControlEx<InformationChannelKind>;

  const updateRequirements = (channel: InformationChannelKind) => {
    if (email.isReadonly && phone.isReadonly) {
      return;
    }

    email.required = channel === InformationChannelKind.Email || channel === InformationChannelKind.EmailAndSms;
    phone.required = channel === InformationChannelKind.Sms || channel === InformationChannelKind.EmailAndSms;
  };

  updateRequirements(informationChannel.value);
  return informationChannel.valueChanges.subscribe(updateRequirements);
}
